import { NgModule } from '@angular/core';
import { ToShortNamePipe } from './to-short-name.pipe';

@NgModule({
  declarations: [ToShortNamePipe],
  exports: [ToShortNamePipe],
})
export class ToShortNamePipeModule {}
